import Queues from './Queues.container';

export default Queues;
